/**
 * Created by praveenningappa on 10/03/17.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { ContentCard } from 'components/SharedComponents/content/content-card';
import { Placeholder } from './../loading-state/placeholder';

export class HomepageSkeleton extends React.Component {
    constructor(props) {
        super(props);
    }

    getContentPlaceholders() {
        const placeholderArray = [];
        const placeholderCount = 20;
        const contentCardProps = { channelLogo: null, channelTitle: '', contentDuration: null,
            contentThumbnail: null,
            contentOnClickHandler: () => {},
            contentHeaderOnClickHandler: () => {},
            contentCategory: null,
            contentTitle: '',
            contentPublishDate: '',
            numOfViews: null,
            isFetching: 1
        };
        for (let i = 0; i < placeholderCount; i++) {
            placeholderArray.push(<ContentCard {...contentCardProps} />);
        }
        return placeholderArray;
    }

    getHomePageSkeleton() {
        return (
            <div>
                <div className="animated fadeIn">
                    <Placeholder height={'80px'} margin={'0px'} type={'plain'} />
                </div>
                <div className="content-card-container">
                    {this.getContentPlaceholders()}
                </div>
            </div>
        );
    }


    render() {
        return (
            <div>
            {this.props.onlyContentPlaceholders ? this.getContentPlaceholders() : this.getHomePageSkeleton()}
            </div>
        );
    }
}

HomepageSkeleton.propTypes = {
    onlyContentPlaceholders: PropTypes.bool
};

HomepageSkeleton.defaultProps = {
    onlyContentPlaceholders: false
};



// WEBPACK FOOTER //
// ./src/components/SharedComponents/loading-state/homepage-skeleton.js